import _ from 'lodash';
import { PRICE_SELECTED } from "pu-data/QuoteSteps";

export const extractFabrication = (arg) => {
  const { quoteStep, parameters, quote } = arg;
  if (quoteStep !== PRICE_SELECTED) return {};

  const { row_selected, column_selected, quote_config_key, supplier_selected } = parameters;

  const lineItem = quote.line_items.find((li) => li.product_key === supplier_selected && li.quote_config_key === quote_config_key);
  if (!lineItem) return {};

  const price = _.round(lineItem.pricing[row_selected][column_selected], 2);
  const quantity = lineItem.options.quantities[row_selected];
  const leadTime = lineItem.lead_times[column_selected];

  const unitPrice = _.round((price / quantity), 2);
  return {
    quantity,
    leadTime,
    unitPrice,
    subTotal: price,
    selected: true,
  };
}